export default __webpack_public_path__ + "static/media/sim-azure-2.29e6db20.jpg";